module.exports = __webpack_public_path__ + "img/product_23.52b5cfe.jpg";